import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const EvidencePage = lazy(() => import('../pages/evidence/page'));
const IntakePage = lazy(() => import('../pages/intake/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const HealthConsequencesPage = lazy(() => import('../pages/health-consequences/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/evidence',
    element: <EvidencePage />,
  },
  {
    path: '/intake',
    element: <IntakePage />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '/health-consequences',
    element: <HealthConsequencesPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
